<template>
  <table v-if="!$_.isEmpty(themes)" class="table is-stretched is-size-7">
    <b-loading :active="pluginOrThemeUpdating" :is-full-page="false" />
    <tbody>
      <tr v-for="theme in themes" :key="theme.id">
        <td>
          <p>
            <a
              :href="`https://wordpress.org/themes/${theme.id.split('/')[0]}`"
              target="_blank"
              class="has-text-dark has-text-weight-semibold"
            >
              <u>{{ theme.name }}</u>
            </a>
            <span>&nbsp;(v{{ theme.version }})</span>
          </p>
          <p v-if="!theme.message" class="is-size-7 has-text-danger">
            {{ theme.message }}
          </p>
        </td>
        <td
          class="has-text-right"
          width="1px"
          :style="{ whiteSpace: 'nowrap' }"
        >
          <a
            v-if="theme.newVersion"
            class="has-text-dark"
            :class="{
              'has-cursor-wait': theme.isProcessing
            }"
            @click="updateTheme(theme)"
          >
            <b-icon
              icon="wrench"
              size="is-small"
              type="is-dark"
              class="has-margin-right-50"
            />
            <u
              >{{ theme.isProcessing ? "Updating" : "Update" }}
              to
              <strong>v{{ theme.newVersion }}</strong>
            </u>
          </a>
          <p v-else class="has-text-success">
            <b-icon icon="check" size="is-small" class="has-margin-right-50" />
            <span>Up to date</span>
          </p>
        </td>
      </tr>
    </tbody>
  </table>
  <div v-else>This site has no themes installed.</div>
</template>

<script>
export default {
  name: "SiteWordpressThemesView",
  props: {
    siteId: {
      required: true,
      type: String
    }
  },

  computed: {
    site() {
      return this.$store.getters["sites/site"](this.siteId);
    },
    plugins() {
      return this.$_.toArray(this.$_.get(this.site, "wordpress.plugins"));
    },
    themes() {
      return this.$_(this.$_.get(this.site, "wordpress.themes", []))
        .toArray()
        .orderBy("name", "asc")

        .value();
    },
    pluginOrThemeUpdating() {
      return !!(
        this.$_.find(this.themes, i => i.isProcessing) ||
        this.$_.find(this.plugins, i => i.isProcessing)
      );
    }
  },
  methods: {
    updateTheme(theme) {
      if (this.pluginOrThemeUpdating) return;

      this.$toast.open({
        message: `Update initiated`
      });

      this.$store
        .dispatch("sites/updateWordpressTheme", {
          siteId: this.siteId,
          slug: theme.id
        })
        .catch(() => {
          this.$toast.open({
            message: `Error updating theme`,
            type: "is-danger"
          });
        });
    }
  }
};
</script>
